import React, { useState } from 'react';
import CustomNavBar from '../../components/customNavBar/customNavBar';
import DotNavBar from '../../components/dotNavBar/dotNavBar';
import DynamicForm from '../../components/dynamicForm/dynamicForm';
import { Container } from 'react-bootstrap';
import dotsModel from '../../models/dotsModel';
import PagesNavigator from '../../components/pagesNavigator/pagesNavigator';
import { useDispatch, useSelector } from 'react-redux';
import saveDataAction from '../../actions/pages/saveDataAction';
import ModalComponent from '../../components/modal/modalComponent';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import clearDataAction from '../../actions/pages/clearDataAction';
import _ from 'lodash';
import loginAction from '../../actions/login/loginAction';
import typeModel from '../../models/typeModels';
import authService from '../../services/authService';
import * as DocumentUploadService from '../../services/documentUploadService';
import LogService from '../../services/logService';

const ExternalReferralPage = (props) => {
  let dataPropertyName = 'basicInformation';
  let history = useHistory();
  let sect = props.model.sections;
  const setBusy = props.setBusy;
  let [sections, setSections] = useState(sect);

  const pagesData = useSelector((state) => state.pagesData.data);
  
  const dispatch = useDispatch();

  const authData = useSelector((state) => state.authData);

  if (!pagesData[dataPropertyName]) {
    pagesData[dataPropertyName] = {};
    if (dataPropertyName === 'basicInformation') {
      if (!pagesData[dataPropertyName].caseManager) {
        pagesData[dataPropertyName].caseManager = {};
      }
      pagesData[dataPropertyName].caseManager.agency = authData.user.agency;
      pagesData[dataPropertyName].caseManager.fullName = authData.user.fullName;
      pagesData.logConfig = authData.user.logConfig;
      if(!pagesData[dataPropertyName].teamMembers){
        pagesData[dataPropertyName].teamMembers = [
          { isOtherTeamMember : false, isEmergencyContact : false},
          { isOtherTeamMember : false, isEmergencyContact : false},
          { isOtherTeamMember : false },
          { isOtherTeamMember : false }
        ];
      }
      if(!pagesData[dataPropertyName].contacts){
        pagesData[dataPropertyName].contacts = [{},{},{},{ comesFromLegalRepresentative : false },{ comesFromLegalRepresentative : false}];
      }

      if(!pagesData[dataPropertyName].options){
        pagesData[dataPropertyName].options = [];
      }

    }

    dispatch(saveDataAction(pagesData));
  }
  

  let [data, updateData] = useState(pagesData[dataPropertyName]);

  
  const [legalRepresentative, setLegalRepresentative] = useState({
    isOtherTeamMember1 : data.teamMembers[0].isOtherTeamMember === true,
    isOtherTeamMember2 : data.teamMembers[1].isOtherTeamMember === true,
    isEmergencyContact1 : data.teamMembers[0].isEmergencyContact === true,
    isEmergencyContact2 : data.teamMembers[1].isEmergencyContact === true,
  });

  if (!pagesData.dots) {
    pagesData.dots = dotsModel();
    dispatch(saveDataAction(pagesData));
  }

  const getEntryValue = (data, entry) => {
    const properties = entry.mapTo?.split('.');
    let value = data;
    properties?.forEach(property => {
      if (value) {
        const arrayIndex = property.indexOf('[');
        if (arrayIndex >= 0) {
          const index = parseInt(property.substring(arrayIndex + 1, property.length - 1));
          value = value[property.substring(0, arrayIndex)];
          if (value) {
            value = value[index];
          }
        } else {
          value = value[property];
        }
      }
    });
    if (value !== data) {
      return value;
    }

    return undefined;
  };

  const validateForm = (sections, data, errors, dispatchData = true) => {
    let isFormValid = true;
    sections.forEach((section) => {
      const result = validateFields(section, data, errors);
      if (!result) {
        isFormValid = false;
      }
    });

    pagesData.dots.forEach((dot) => {
      if (dot.path === history.location.pathname) {
        dot.hasError = !isFormValid;
      }
    });

    if (dispatchData) {
      setSections(sections);
      dispatch(saveDataAction(pagesData));
    }
    return isFormValid;
  };

  const validateFields = (section, data, errors) => {
    let isFormValid = true;
    section.rows.forEach((row) => {
      row.cols.forEach((column) => {
        column.isInvalid = false;
        if (_.isArray(column.sections)) {
          column.sections.forEach((columnSection) => {
            const result = !validateFields(columnSection, data, errors);
            if (result) {
              column.isInvalid = true;
            }
          });
        } else if (_.isArray(column.rows)) {
          column.isInvalid = !validateFields(column, data, errors);
        } else if(column.type === 'radio' && column.options && column.options.some( item => item.commentsAreRequired && item.isRequiredValid)) {
          const optionsToValidate = column.options.filter( item => item.commentsAreRequired && item.isRequiredValid);
          optionsToValidate.forEach(option => {
            option.isInvalid = !option.isRequiredValid(data)  ;
          });
          column.isInvalid = optionsToValidate.some( item => item.isInvalid);
        }else {
          let value = getEntryValue(data, column);
          if (column.required && (!value || value.trim() === '')) {
            column.isInvalid = true;
          } else if (column.validation) {
            column.isInvalid = !column.validation(section, column, data, value, errors);
          } else if (column.type === 'date') {
            if (value) {
              const date_regex = /^\d{4}-\d{2}-\d{2}$/;
              if (!date_regex.test(value)) {
                column.isInvalid = true;
              } else {
                const date = new Date(value);
                if (isNaN(date.getTime()) || date.getFullYear() < 1800) {
                  column.isInvalid = true;
                }
              }
            }
          } else if (column.isSocialSecurityNumber && value) {
            const ssn_regex = /^\d{3}-?\d{2}-?\d{4}$/;
            if (!ssn_regex.test(value)) {
              column.isInvalid = true;
            }
          } else if (column.isPhoneNumber && value) {
            const phone_regex = /^(\+[0-9])?(-|\s)?(\()?[2-9]{1}\d{2}(\))?(-|\s)?[2-9]{1}\d{2}(-|\s)\d{4}$/;
            if (!phone_regex.test(value)) {
              column.isInvalid = true;
            }
          } else if (column.isEmail && value) {
            const email_regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!email_regex.test(value)) {
              column.isInvalid = true;
            }
          }
        }

        if (column.isInvalid) {
          isFormValid = false;
        }
      });
    });

    return isFormValid;
  };

  const doesExistsData = (obj) => {
    return obj && ((obj.firstName && obj.firstName !== '') || 
      (obj.lastName && obj.lastName !== '') ||
      (obj.email && obj.email !== '') ||
      (obj.workPhoneNumber && obj.workPhoneNumber !== ''));
  };

  const copyFromTo = (from, to) =>{
    if(!from || !to){
      return;
    }
    to.firstName = from.firstName;
    to.lastName = from.lastName;
    to.email = from.email;
    to.workPhoneNumber = from.workPhoneNumber;
  };

  const clearData = (obj) => {
    obj.firstName = '';
    obj.lastName = '';
    obj.email = '';
    obj.workPhoneNumber = '';
  };

  const changeDataHandler = (newData) => {        


    if(newData.teamMembers[0] && newData.teamMembers[0].isOtherTeamMember) {

      const justChanged = legalRepresentative.isOtherTeamMember1 !== newData.teamMembers[0].isOtherTeamMember;
      const alreadyExistsData = doesExistsData(data.teamMembers[2]);
      
      const process = () => {
        copyFromTo(newData.teamMembers[0], newData.teamMembers[2]);       
      };

      if(!justChanged || (justChanged && !alreadyExistsData)){
        process();      
      }else if (justChanged && alreadyExistsData) {
        const result = window.confirm('Do you want to replace the existing Family/Other Team Members with the information of the Legal Representative?');
        if(result) {
          process();
        }else{
          newData.teamMembers[0].isOtherTeamMember = false;          
        }
      }
      
    } else if(newData.teamMembers[0] && !newData.teamMembers[0].isOtherTeamMember){
      const justChanged = legalRepresentative.isOtherTeamMember1 !== newData.teamMembers[0].isOtherTeamMember;
      if(justChanged){
        clearData(newData.teamMembers[2]);
      }
    }
    newData.teamMembers[2].isOtherTeamMember = newData.teamMembers[0].isOtherTeamMember;

    if(newData.teamMembers[1] && newData.teamMembers[1].isOtherTeamMember) {

      const justChanged = legalRepresentative.isOtherTeamMember2 !== newData.teamMembers[1].isOtherTeamMember;
      const alreadyExistsData = doesExistsData(data.teamMembers[3]);

      const process = () => {
        copyFromTo(newData.teamMembers[1], newData.teamMembers[3]);
      };

      if(!justChanged || (justChanged && !alreadyExistsData)){
        process();      
      }else if (justChanged && alreadyExistsData) {
        const result = window.confirm('Do you want to replace the existing Family/Other Team Members with the information of the Legal Representative?');
        if(result) {
          process();
        }else{
          newData.teamMembers[1].isOtherTeamMember = false;          
        }
        
      }
      
    }else if(newData.teamMembers[0] && !newData.teamMembers[1].isOtherTeamMember){
      const justChanged = legalRepresentative.isOtherTeamMember2 !== newData.teamMembers[1].isOtherTeamMember;
      if(justChanged){
        clearData(newData.teamMembers[3]);
      }
    }
    newData.teamMembers[3].isOtherTeamMember = newData.teamMembers[1].isOtherTeamMember;

    if(newData.teamMembers[0] && newData.teamMembers[0].isEmergencyContact) {

      const justChanged = legalRepresentative.isEmergencyContact1 !== newData.teamMembers[0].isEmergencyContact;
      const alreadyExistsData = doesExistsData(data.contacts[3]);

      const process = () => {
        copyFromTo(newData.teamMembers[0], newData.contacts[3]);
      };

      if(!justChanged || (justChanged && !alreadyExistsData)){
        process();      
      }else if (justChanged && alreadyExistsData) {
        const result = window.confirm('Do you want to replace the existing Emergency Contact with the information of the Legal Representative?');
        if(result) {
          process();
        }else{
          newData.teamMembers[0].isEmergencyContact = false;
        }
      }
    }else if(newData.teamMembers[0] && !newData.teamMembers[0].isEmergencyContact){
      const justChanged = legalRepresentative.isEmergencyContact1 !== newData.teamMembers[0].isEmergencyContact;
      if(justChanged){
        clearData(newData.contacts[3]);
      }
    }
    data.contacts[3].comesFromLegalRepresentative = newData.teamMembers[0].isEmergencyContact;

    if(newData.teamMembers[1] && newData.teamMembers[1].isEmergencyContact) {


      const justChanged = legalRepresentative.isEmergencyContact2 !== newData.teamMembers[1].isEmergencyContact;
      const alreadyExistsData = doesExistsData(data.contacts[4]);

      const process = () => {
        copyFromTo(newData.teamMembers[1], newData.contacts[4]);
      };

      if(!justChanged || (justChanged && !alreadyExistsData)){
        process();      
      }else if (justChanged && alreadyExistsData) {
        const result = window.confirm('Do you want to replace the existing Emergency Contact with the information of the Legal Representative?');
        if(result) {
          process();
        }else{
          newData.teamMembers[1].isEmergencyContact = false;
        }
        
      }
    }else if(newData.teamMembers[0] && !newData.teamMembers[1].isEmergencyContact){
      const justChanged = legalRepresentative.isEmergencyContact2 !== newData.teamMembers[1].isEmergencyContact;
      if(justChanged){
        clearData(newData.contacts[4]);
      }
    }
    data.contacts[4].comesFromLegalRepresentative = newData.teamMembers[1].isEmergencyContact;

    if(newData.riskLevel && newData.riskLevel.id !== '2'){
      newData.riskLevel2Comments = '';
    }
    if(newData.riskLevel && newData.riskLevel.id !== '3'){
      newData.riskLevel3Comments = '';
    }
    if(newData.programId){
      newData.program = newData.programId.option;
    }

    updateData(newData);
    pagesData[dataPropertyName] = newData;

    
    setLegalRepresentative({
      isOtherTeamMember1: newData.teamMembers[0].isOtherTeamMember,
      isOtherTeamMember2: newData.teamMembers[1].isOtherTeamMember,
      isEmergencyContact1: newData.teamMembers[0].isEmergencyContact,
      isEmergencyContact2: newData.teamMembers[1].isEmergencyContact
    });

    dispatch(saveDataAction(pagesData));
      
  };

  const [showModal, setShow] = useState(false);

  const handleClose = () => setShow(false);

  let [attachmentManager, updateAttachmentData] = useState(() => {
    return !pagesData.attachmentManager ? {} : pagesData.attachmentManager;
  });
  const AttachmentChangeHandler = (name, value) => {
    attachmentManager[name] = value;
    updateAttachmentData(attachmentManager);
    pagesData.attachmentManager = attachmentManager;
    dispatch(saveDataAction(pagesData));
  };

  const mainControl = {
    onChangeHandler: changeDataHandler,
    onAttachmentChangeHandler: AttachmentChangeHandler,
    getAttachmentsInfo: function get() { return attachmentManager; },
    getLogConfig: () => { return pagesData.logConfig; },
    getReferralUniqueId: () => {
      const referralGuid = attachmentManager[DocumentUploadService.referralGuidKey];
      if (referralGuid === undefined) {
        DocumentUploadService.getUniqueId()
          .then(({ data }) => {
            AttachmentChangeHandler(DocumentUploadService.referralGuidKey, data);
            return true;
          });
      }
      return referralGuid;
    },
    setBusy: (show) => { if (setBusy) setBusy(show); }
  };

  mainControl.getReferralUniqueId();

  if (history.location.state && (history.location.state.from !== '/' && history.location.state.from !== history.location.state.pathname)) {
    let errors = [];
    validateForm(sections, data, errors, false);
  }

  const clearEmpties = (o) => {
    for (var k in o) {
      if (typeof o[k] !== 'object' && !o[k] && o[k] !== false) {
        delete o[k];
        continue;
      } else if (!o[k] || typeof o[k] !== 'object') {
        continue;
      }

      clearEmpties(o[k]);
      if (Object.keys(o[k]).length === 0) {
        delete o[k];
      }
    }
  };

  const cleanArraysOnObject = (obj) => {
    const typeModels = typeModel();

    for (const property in obj) {
      let model = obj[property];
      if (!model || !_.isArray(model)) {
        continue;
      }

      let newArray = [];
      model.forEach((item, index) => {
        if (!_.isEmpty(item)) {
          let newItem = typeModels[property] ?
            {
              ...item, ...typeModels[property][index]
            } : item;
          
          const onlyHasDefault = (Object.keys(newItem).length === 3 && 
                                 newItem.hasOwnProperty('type') && 
                                 newItem.hasOwnProperty('isOtherTeamMember') && 
                                 newItem.hasOwnProperty('isEmergencyContact')) || 
                                 
                                 (Object.keys(newItem).length === 2 && 
                                 (newItem.hasOwnProperty('type') && 
                                  (newItem.hasOwnProperty('isOtherTeamMember') || newItem.hasOwnProperty('isEmergencyContact')))) ||
                                  
                                 (Object.keys(newItem).length === 2 && 
                                 newItem.hasOwnProperty('type') && 
                                 newItem.hasOwnProperty('comesFromLegalRepresentative'));

          if(!onlyHasDefault){
            newArray.push(newItem);
          }
        }
      });

      if (newArray.length === 0) {
        obj[property] = null;
      } else {
        obj[property] = newArray;
      }
    }
  };

  const transformObjectToId = (o) => {
    for (var k in o) {
      if (!o[k] || typeof o[k] !== 'object') {
        continue;
      }
      if (_.has(o[k], 'option') && _.has(o[k], 'id')) {
        o[k] = o[k].id;
      }
    }
  };

  const saveAction = () => {
    const log = {
      referralGuid: attachmentManager.referralGuid,
      data: pagesData.basicInformation
    };

    try {
      if (validateAndUpdate()) {
        const SERVER_URL = `${authService.getCaseManagerBasePath()}/api`;
        let toBeSend = {
          referralGuid: attachmentManager.referralGuid,
          consumer: pagesData.basicInformation,
          caseManager: pagesData.basicInformation.caseManager,
          program: pagesData.basicInformation.program,
          programId: pagesData.basicInformation.programId ? pagesData.basicInformation.programId.id : -1,
        };

        if (pagesData.basicInformation.program) {
          toBeSend.program = pagesData.basicInformation.program;
        }

        let cleanData = _.cloneDeep(toBeSend);
        delete cleanData.consumer.caseManager;
        clearEmpties(cleanData);

        cleanArraysOnObject(cleanData.consumer);
        transformObjectToId(cleanData.consumer);

        mainControl.setBusy(true);
        authService.getToken().then((authResponse) => {
          axios.post(`${SERVER_URL}/referrals`, cleanData, { headers: { Authorization: `Bearer ${authResponse.data.access_token}` } },).then(() => {
            setModalData(getSaveSuccessModalData());
            setShow(true);
          })
            .catch((err) => {
              logError(err, log);
              setModalData(getSaveErrorModalData());
              setShow(true);
            })
            .finally(() => {
              mainControl.setBusy(false);
            });
          return true;
        })
          .catch((err) => {
            mainControl.setBusy(false);
            logError(err, log);
            setModalData(getSaveErrorModalData());
            setShow(true);
          });
      }
    } catch (e) {
      mainControl.setBusy(false);
      logError(e, log);
      setModalData(getSaveErrorModalData());
      setShow(true);
    }
  };

  const handleGoLogin = () => {
    clearAllData();
    history.push('/');
  };

  const handleNewReferral = () => {
    clearAllData();
    history.push(pagesData.dots[0].path, { from: history.location.pathname });
  };

  const clearAllData = () => {
    dispatch(clearDataAction());

    updateAttachmentData({});
  };

  const cancelAllAction = () => {
    setModalData(getCancelModalData());
    setShow(true);
  };

  const [modal, setModalData] = useState({
    tile: '',
    message: '',
    okLabel: 'Ok',
    closeLabel: undefined,
    onOk: handleClose,
    onCancel: undefined
  });
  const getWarningModalData = (warningMessage) => {
    if (!warningMessage) {
      warningMessage = 'You have not completed all the required information or some fields are not valid. You will need to go back to this page if you want to save this form';
    }
    return {
      title: 'Warning',
      message: warningMessage,
      okLabel: 'Ok',
      cancelLabel: undefined,
      onOk: handleClose,
      onCancel: undefined
    };
  };
  const getSaveSuccessModalData = () => {
    return {
      title: 'Saved',
      message: 'Form saved successfully. \nWould you like to enter a new referral?',
      okLabel: 'Yes',
      cancelLabel: 'No',
      onOk: handleNewReferral,
      onCancel: handleGoLogin
    };
  };
  const getCancelModalData = () => {
    return {
      title: 'Warning',
      message: 'If you cancel now, all the information will be lost.',
      okLabel: 'Cancel Anyway',
      cancelLabel: 'Take me back',
      onOk: handleNewReferral,
      onCancel: handleClose
    };
  };

  const logError = (err, log) => {
    const config = mainControl.getLogConfig();
    if (config?.isEnabled === true) {
      const id = mainControl.getReferralUniqueId();
      const message = JSON.stringify(err);
      const data = config?.logData === true ? JSON.stringify(log) : null;
      LogService.log(id, message, data);
    }
  };

  const trim = function(str){
    return str ? str.trim() : str;
  };

  const getSaveErrorModalData = () => {
    return {
      title: 'Error',
      message: 'Save failed. \nPlease try again.',
      okLabel: 'Ok',
      onOk: handleClose
    };
  };

  const validateAndUpdate = () => {
    let errors = [];
    let response = validateForm(sections, data, errors);

    authData.user.agency = trim(pagesData[dataPropertyName].caseManager.agency);
    authData.user.fullName = trim(pagesData[dataPropertyName].caseManager.fullName);

    dispatch(loginAction(authData));
    dispatch(saveDataAction(pagesData));

    let warningMessage = null;
    if (!response) {
      warningMessage = errors.join('\n');
    }

    if (response){
      if (attachmentManager && attachmentManager.progressInfo){
        const uploadInProgress = attachmentManager.progressInfo.find((f) => f.isWaiting === true);
        if (uploadInProgress){
          response = false;
          warningMessage = 'Files are being uploaded, please wait.';
        }
      }
    }

    setModalData(getWarningModalData(warningMessage));
    setShow(!response);
    return response;
  };

  return (
    <div className="main-bg">
      <CustomNavBar></CustomNavBar>
      <Container>
        <DotNavBar
          items={pagesData.dots}
          beforeNext={validateAndUpdate}
        ></DotNavBar>
        <div className="form-container">
          <DynamicForm
            sections={sections}
            mainControl={mainControl}
            data={data}
          ></DynamicForm>
          <PagesNavigator
            beforeNext={validateAndUpdate}
            pages={pagesData.dots}
            saveClick={saveAction}
            cancelClick={cancelAllAction}
          ></PagesNavigator>
        </div>
        <ModalComponent
          title={modal.title}
          message={modal.message}
          show={showModal}
          okBtn={modal.okLabel}
          closeBtn={modal.cancelLabel}
          handleOk={modal.onOk}
          handleCancel={modal.onCancel}
        ></ModalComponent>
      </Container>
    </div>
  );
};

export default ExternalReferralPage;
